var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCheck(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.5068 5.44708C20.8121 5.72697 20.8327 6.2014 20.5528 6.50674L17.8028 9.50674C17.5229 9.81208 17.0485 9.8327 16.7432 9.55281C16.4378 9.27291 16.4172 8.79849 16.6971 8.49315L19.4471 5.49315C19.727 5.18781 20.2014 5.16718 20.5068 5.44708ZM15.5068 10.9016C15.8121 11.1815 15.8328 11.6559 15.5529 11.9612L9.55284 18.5067C9.41461 18.6575 9.22078 18.7453 9.01626 18.7498C8.81175 18.7542 8.61429 18.6749 8.46964 18.5303L3.46964 13.5303C3.17675 13.2374 3.17675 12.7625 3.46964 12.4696C3.76253 12.1767 4.23741 12.1767 4.5303 12.4696L8.97641 16.9157L14.4471 10.9477C14.727 10.6423 15.2015 10.6217 15.5068 10.9016Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.19648102.svg";
export { ForwardRef as ReactComponent };